// Ingestion run detail route (/ops/runs/$runUid): the open step in the URL; the screen is RunDetailPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { optionalString } from "@/app/search";
import { RunDetailPage } from "@/features/operations/RunDetailPage";

const searchSchema = z.object({
  step: optionalString(),
});

export const Route = createFileRoute("/_app/ops/runs/$runUid")({
  validateSearch: searchSchema,
  staticData: { crumb: "Run" },
  component: RunDetailPage,
});
